function initMatchHeight() {
	$('.data-mh' ).matchHeight();
	$.fn.matchHeight._maintainScroll = true;
}

function matchHeightReset() {
	$.fn.matchHeight._beforeUpdate = function(event, groups) {
		$( '[data-mh]').css('height', '' );
	};
	$.fn.matchHeight._update();
}